import React from 'react';

import { Badge, Button, FilterListIcon, makeStyles } from '@gogame/components';

const useStyles = makeStyles(() => ({
  root: {
    borderRightColor: `rgba(79, 119, 160, 0.5)!important`,
  },
}));

const FiltersButton = ({
  tooltip = 'Open filters',
  badge = false,
  badgeColor = 'error',
  onClick,
}) => {
  const classes = useStyles();
  let icon = <FilterListIcon />;

  if (badge) {
    icon = (
      <Badge color={badgeColor} variant={'dot'}>
        {icon}
      </Badge>
    );
  }

  return (
    <Button
      icon={icon}
      className={classes.root}
      tooltip={tooltip}
      tooltipPlacement={'bottom'}
      onClick={onClick}
      variant={'outlined'}
    >
      Filters
    </Button>
  );
};

export default FiltersButton;
